import * as req from 'api/actions';
import * as c from './constant';

export const assessReceipt = (id, payload, callback) =>
  req.update(
    c.ASSESS_RECEIPT,
    `/api/v1/administrators/transaction_histories/${id}/assess_payment_receipt`,
    payload,
    callback,
    res => {
      const { message } = res.res;
      alert.success(message || 'Successfully Updated !');
      if (callback) callback();
    }
  );

export const getTransactionList = (
  payload = { module_type: 'RPTAXC' },
  callback
) =>
  req.list(
    c.GET_TRANSACTION,
    'api/v1/administrators/transaction_histories/',
    payload,
    callback
  );

export const showTransaction = (id, payload, callback) =>
  req.item(
    c.SHOW_TRANSACTION,
    `api/v1/administrators/transaction_histories/${id}`,
    payload,
    callback
  );

export const approveTransaction = (id, payload, callback) =>
  req.update(
    c.APPROVE_TRANSACTION,
    `api/v1/administrators/transaction_histories/rptax_clearance/${id}/approve`,
    payload,
    callback,
    res => {
      const { message } = res.res;
      alert.success(message || 'Successfully Updated !');
      if (callback) callback();
    }
  );

export const rejectTransaction = (id, payload, callback) =>
  req.update(
    c.REJECT_TRANSACTION,
    `api/v1/administrators/transaction_histories/rptax_clearance/${id}/reject`,
    payload,
    callback,
    res => {
      const { message } = res.res;
      alert.success(message || 'Successfully Updated !');
      if (callback) callback();
    }
  );

export const startAssessment = (id, callback) =>
  req.update(
    c.START_ASSESSMENT,
    `api/v1/administrators/transaction_histories/${id}/start_assessment`,
    callback,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const receiveTransaction = (id, payload, callback) =>
  req.update(
    c.RECEIVE_TRANSACTION,
    `api/v1/administrators/transaction_histories/rptax_clearance/${id}/tag_as_received`,
    payload,
    callback,
    res => {
      const { message } = res.res;
      alert.success(message || 'Successfully Updated !');
      if (callback) callback();
    }
  );

export const getTransactionCount = (
  payload = { module_type: 'RPTAXC', transaction_status: 'FOR CHECKING' },
  callback
) =>
  req.list(
    c.GET_TRANSACTION_COUNT,
    'api/v1/administrators/transaction_histories/rptax_clearances',
    payload,
    callback
  );

export const clearTransaction = () => req.setList(c.GET_TRANSACTION, []);

export const generateTransmittal = (payload, callback) =>
  req.create(
    c.GENERATE_TRANSMITTAL,
    `api/v1/administrators/rptax_clearance/transmittal/generate`,
    payload,
    callback
  );

export const reassess = (id, payload, callback) =>
  req.update(
    c.REASSESS,
    `api/v1/administrators/transaction_histories/rptax_clearance/${id}/reassess`,
    payload,
    callback
  );